<template>
  <div class="menu-list" style="z-index:99;top: 70px;">
        <div v-bind:class="[$store.state.mainLeftMenu==item.id?'menu-active':'','menu-div']" v-for="item in menuList" :key="item.id" @click="menuClickEvent(item)">
            <div class="menu-img-div">
              <img class="menu-img" :src="item.imgurl"/>
            </div>
            <div class="text">{{item.name}}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      // $store.state.mainLeftMenu:2,
      menuList:[],
    }
  },
  methods: {
    menuClickEvent(obj){
      if(obj.id==1){
        this.$router.push({name: 'templist'});
      }else if(obj.id==2){
        if(this.$store.state.mainLeftMenu!=2) this.$router.push({name: 'list'});
      } else if(obj.id==3){
        if(this.$store.state.mainLeftMenu!=3) this.$router.push({name: 'serverManager'});
      }
    }
  },
  created(){
    let _this = this;
    var uid = getCookieV('userid1');
    var token = getCookieV('token1');
    _this.axios({
      method: 'post',
      url: _this.api.menuList,
      params: {
        uid: uid,
        tk: token,
      },
    }).then(res=>{
      let data = res.data;
      if(data.code==200){
        _this.menuList = data.data;
      }else if(data.code==-1){
          window.location.href = _this.api.loginHtmlUrl;
      }
    }).catch(function(){
        commonErrorTip(_this);
    })
  },
  mounted() {
    if(this.$route.name=='serverManager') this.$store.state.mainLeftMenu=3;
  }
}
</script>

<style lang="scss">
    .menu-img-div{
      align-items: center;justify-content: center;display: flex;
    }
    .menu-div .text{
      text-align:center
    }
    .menu-active{
      background: #E6EAF1;
    }
    .menu-img{
      width:42px;
      height:42px;
    }
</style>